<template>
    <div class="content">
        <div class="how-get-credit">
            <div class="how-get-credit__block">
                <div class="how-get-credit__content">
                    <div class="how-get-credit__title">
                        <h1 class="how-get-credit__title--h1">Как получить<br/> микрокредит</h1>
                        <p class="how-get-credit__title--info">Просто заполните <br/>анкету на сайте</p>
                    </div>
                    <div class="how-get-credit__description">
                        <p class="how-get-credit__description--title">для этого понадобятся:</p>
                        <ul class="how-get-credit__list">
                            <li class="how-get-credit__item">
                                <span v-if="!isMobileSM" class="icon icon--m icon--passport-y"></span>
                                <span v-if="isMobileSM" class="icon icon--m icon--passport"></span>
                                Удостоверение личности <br/>или паспорт гражданина РК
                            </li>
                            <li class="how-get-credit__item">
                                <span v-if="!isMobileSM" class="icon icon--m icon--iban-y"></span>
                                <span v-if="isMobileSM" class="icon icon--m icon--iban"></span>
                                IBAN вашего счёта <br/>в казахстанском банке
                            </li>
                            <li class="how-get-credit__item">
                                <span class="icon icon--m"></span>
                                В случае одобрения заявки мы переведем <br/>деньги на ваш банковский счёт
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="how-get-credit__info">
                    <span class="icon icon--m icon--info-w"></span>
                    IBAN – это 20-значный номер вашего банковского счёта. Вы найдёте его в договоре с вашим банком, личном кабинете на сайте банка или узнаете в службе поддержки
                </div>
            </div>
        </div>
        <div class="step-get-credit">
            <ul class="step-get-credit__steps-list">
                <li class="step-get-credit__step" v-for="item in stepGetCredit" :key="item.id">
                    <img v-bind:src="item.image" v-bind:alt="item.image_alt" class="step-get-credit__step-icon">
                    <p class="step-get-credit__step-description" v-html="item.text"></p>
                </li>
            </ul>
            <router-link class="step-get-credit__button button button--violet" tag="a" :to="{name: 'Micro' }">Подать заявку</router-link>
        </div>
        <call-center
            :type="'block'"
            :color="'yellow'"
        ></call-center>
    </div>
</template>
<script>
  import widthMixin from '@/modules/mixins/widthMixin';
  export default {
    name: "HowToGet",
    metaInfo: {
      title: 'Как получить микрокредит – Микро',
        meta: [
            {name: 'description', content: 'Зарегистрируйтесь на microfin.kz. Заполните анкету. В течение 30 минут мы сообщим о решении. Подпишите договор ОТП. Получите деньги на счёт в банке или на карту'}
        ],
    },
    mixins: [widthMixin],
    data(){
      return {
	      stepGetCredit: [
              {
                  image: require('@/assets/img/index/how-get-credit-1.svg'),
                  image_alt: '1',
                  text: 'Зарегистрируйтесь <br/> на microfin.kz'
              },
            //   {
            //       image: require('@/assets/img/index/how-it-work-2.svg'),
            //       image_alt: '1',
	        //       text: 'Заполните анкету и приложите фотографию удостоверения личности'
            //   },
              {
                  image: require('@/assets/img/index/how-get-credit-2.svg'),
                  image_alt: '1',
	              text: 'В течение 30 минут мы сообщим о решении в личном кабинете и SMS - уведомлением'
              },
              {
                  image: require('@/assets/svg/icons/illust_mk_1.svg'),
                  image_alt: '1',
                  text: 'Подпишите договор'
              },
              {
                  image: require('@/assets/img/index/how-get-credit-5.svg'),
                  image_alt: '1',
                  text: 'Получите деньги на счёт в банке или на карту'
              },
          ]
      }
    }
  }
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.how-get-credit {
    position: relative;
    left: -6vw;
    background-image: url('~@/assets/img/how-to-get/howget_desktop.png');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    max-width: 907px;
    min-height: 620px;
    width: 100%;
    display: flex;
    margin: 0 auto 30px;
    justify-content: flex-start;

    &__block {
        max-width: 450px;
        width: 100%;
        text-align: left;
        margin-left: 70px;
        margin-top: 100px;
    }
    &__content {
        margin-left: 40px;
    }
    &__title--h1 {
        margin-bottom: 19px;
        font-family: $MontserratBold;
        font-size: 30px;
        font-weight: 800;
        line-height: 1.2;
        color: $yellow-site;
        br {
            display: none;
        }
    }
    &__title--info {
        color: $white;
        font-family: $RobotoMedium;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        br {
            display: none;
        }
    }
    &__description--title {
        margin-bottom: 20px;
        font-family: $RobotoMedium;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        color: $white;
    }
    &__list {
        list-style-type: none;
    }
    &__item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        vertical-align: top;
        color: #ffffff;
        font-family: $RobotoMedium;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;

        .icon--m {
            width: 61px;
            min-width: 61px;
        }
        .icon--passport,
        .icon--passport-y {
            height: 49px;
        }
        .icon--iban,
        .icon--iban-y {
            height: 58px;
        }
    }
    &__item:last-child {
        margin-top: 20px;
        margin-bottom: 19px;
        font-size: 14px;
        line-height: 20px;
    }
    &__info {
        width: 483px;
        padding: 16px 24px;
        background: $tooltip_background;
        box-sizing: border-box;
        color: $gray-dim-dark;
        font-family: $RobotoRegular;
        font-size: 14px;
        line-height: 24px;
        .icon {
            min-width: unset;
            min-height: unset;
            width: 26px;
            height: 22px;
            vertical-align: text-bottom;
        }
    }
}
.step-get-credit {
    margin-bottom: 100px;

    &__steps-list {
        display: flex;
        max-width: 1024px;
        flex-flow: row wrap;
        justify-content: center;
        margin: 30px auto 10px;
        list-style-type: none;
    }
    &__step {
        position: relative;
        display: inline-flex;
        flex: 0 0 50%;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 50px;

        &:nth-child(1),
        &:nth-child(3){
            &:after{
                position: absolute;
                top: 30px;
                right: -6.4vw;

                display: block;
                content: '';
                background: url("~@/assets/svg/icons/line_howtoget.svg") center no-repeat;
                width: 14vw;
                height: 33px;
            }
        }
        &:nth-child(1) {
            .step-get-credit__step-description {
                align-self: center;
                text-align: center;
                width: 240px;
            }
        }
        &:nth-child(2) {
            &:after {
                top: 120px;
                right: -87px;
                transform: rotate(180deg);
            }
        }
    }
    &__step-icon {
        max-width: 145px;
        width: 100%;
        max-height: 135px;
        height: 100%;
    }
    &__step-description {
        max-width: 260px;
        margin-top: 15px;
        text-align: center;
        width: 100%;
        color: $gray-dim-dark;
        font-family: $RobotoRegular;
        font-size: 16px;
    }
    &__button {
        width: 300px;
        text-decoration: none;
    }
}
@media screen and (max-width: 1024px) {
    .step-get-credit {
        &__step-description {
            width: 100%;
            max-width: unset;
            padding: 0 10px;
            text-align: center;
        }
        &__step {
            &:nth-child(1) {
                .step-get-credit__step-description {
                    align-self: center;
                }
            }
        }
    }
    .how-get-credit {
        left: 0;
        background: $purple-site url('~@/assets/img/how-to-get/howget_desktop.png') no-repeat left 50%;
        background-size: contain;
        min-height: 600px;
        max-width: unset;
        &__block {
            margin-left: 15px;
        }
        &__content {
            margin: 0;
        }
        &__item {
            width: 350px;
            br {
                display: none;
            }
            &:last-child .icon {
                display: none;
            }
        }
    }
}
@media screen and (max-width: 700px) {
    .step-get-credit {
        &__steps-list {
            flex-flow: column wrap;
            width: 280px;
        }
        &__step {
            width: 100%;
        }
        &__step-description {
            width: 230px;
            text-align: left;
        }
        &__step:nth-child(2n + 1) {
            &:after{
                position: absolute;
                display: block;
                content: '';
                top: 70px;
                right: unset;
                left: 10px;
                width: 72px;
                height: 190px;
                background: url("~@/assets/svg/icons/line_howtoget-v.svg") center no-repeat;
            }
            .step-get-credit__step-description {
                align-self: center;
            }
        }
        &__step:nth-child(2n + 2) {
            &:after{
                position: absolute;
                display: block;
                content: '';
                top: 100px;
                right: 10px;
                left: unset;
                width: 72px;
                height: 190px;
                background: url("~@/assets/svg/icons/line_howtoget-v.svg") center no-repeat;
                transform: rotate(180deg);
            }
            .step-get-credit__step-description {
                align-self: flex-start;
            }
        }
        &__step:last-child {
            &:after {
                display: none;
            }
        }

    }
    .how-get-credit {
        background: url('~@/assets/img/how-to-get/htg_mobile_kv.png') top center / 120vw no-repeat;
        min-height: unset;
        &__block {
            max-width: unset;
            margin: 0;
        }
        &__title {
            margin: 26vw 0 0 4vw;
            height: 64vw;
        }
        &__title--h1 {
            color: $white;
            font-size: 32px;
            br {
                display: inline;
            }
        }
        &__description {
            width: 330px;
            margin: 0 auto;
        }
        &__description--title {
            text-transform: capitalize;
            color: $black;
        }
        &__item {
            color: $black;
        }
        &__info {
            width: 90%;
            margin: 0 auto;
        }
    }
}
@media screen and (max-width: 500px) {
    .how-get-credit {
        &__item {
            width: 100%;
        }
        &__title {
            margin: 22vw 0 0 4vw;
            height: 64vw;
        }
        &__title--h1 {
            margin-bottom: 9px;
            font-size: 26px;
        }
        &__title--info {
            br {
                display: inline;
            }
        }
        &__description {
            width: 90%;
        }
    }
}
@media screen and (max-width: 340px) {
    .how-get-credit {
        &__title--h1 {
            font-size: 22px;
        }
        &__title--info {
            font-size: 16px;
            line-height: 20px;
        }
    }
}
</style>
